export default __webpack_public_path__ + "static/10561-b523efbae4bd163ae792f586ce3ae428.jpg";